import React, { useEffect, useState } from 'react';
import Header from '../../../../../component/common/landing-page/widgets/Header';
import axios from 'axios';

export default function PrivacyPolicies() {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPrivacy = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_NODE_API_URL}/organization-details`
                );
                if (res.data?.data?.privacy_policy) {
                    setContent(res.data.data.privacy_policy);
                }
            } catch (e) {
                console.error('Error loading privacy policy:', e);
            }
            setLoading(false);
        };
        fetchPrivacy();
    }, []);

    return (
        <div className='d-flex flex-column landing-page-wrapper'>
            <Header />
            <div className="flex-grow-1 main-content-wrap">
                <div className="content-section section-padding right-media">
                    <div className="container">
                        <div className="text-wrap content-page-wrapper">
                            {loading ? (
                                <div className="text-center py-5">
                                    <span className="spinner-border spinner-border-sm" role="status"></span>
                                    <span className="ms-2">Loading...</span>
                                </div>
                            ) : content ? (
                                <div className="text-part" dangerouslySetInnerHTML={{ __html: content }} />
                            ) : (
                                <p style={{ color: '#666' }}>No privacy policy content has been added yet.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
